window.show_dropdown = function(layer){
  var layer_to_show = document.getElementById(layer);
  if(layer_to_show.style.display === "none" || layer_to_show.style.display === ""){
    layer_to_show.style.display = "block";
  } else {
    layer_to_show.style.display = "none";
  }
  return false;
}
